module.exports = __webpack_public_path__ + "img/p1.20e1830.png";